var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDarkmode = function SvgDarkmode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.382 5.28c7.777 0 14.083 6.306 14.083 14.085 0 7.779-6.306 14.085-14.083 14.085C6.6 33.453.295 27.143.295 19.365.295 11.587 6.6 5.28 14.382 5.28Z",
    fill: "#E0F2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.424 13.758a.624.624 0 0 1-.042.684 3.324 3.324 0 0 0 .329 4.361 3.42 3.42 0 0 0 4.413.325.644.644 0 0 1 .691-.042c.22.122.345.36.322.607a5.711 5.711 0 0 1-1.19 2.988 5.813 5.813 0 0 1-2.626 1.89 5.881 5.881 0 0 1-3.241.204 5.836 5.836 0 0 1-2.847-1.546 5.73 5.73 0 0 1-1.564-2.814 5.686 5.686 0 0 1 .206-3.204 5.753 5.753 0 0 1 1.913-2.595 5.855 5.855 0 0 1 3.022-1.176.64.64 0 0 1 .614.318Zm-1.746 1.231c-.396.154-.77.364-1.11.624a4.491 4.491 0 0 0-1.494 2.026 4.44 4.44 0 0 0-.161 2.502 4.475 4.475 0 0 0 1.221 2.197 4.556 4.556 0 0 0 2.223 1.207c.842.186 1.72.13 2.531-.159a4.539 4.539 0 0 0 2.05-1.476c.263-.336.475-.706.632-1.097a4.715 4.715 0 0 1-1.809.22 4.69 4.69 0 0 1-2.952-1.339 4.588 4.588 0 0 1-1.353-2.918 4.562 4.562 0 0 1 .222-1.787Z",
    fill: "#0086C9"
  })));
};

export default SvgDarkmode;